// Generated from tables.ts: literal ids for the VM switch statements.

export const enum VAR {
  TEMP0 = 0,
  TEMP1 = 1,
  TEMP2 = 2,
  TEMP3 = 3,
  TEMP4 = 4,
  TEMP5 = 5,
  TEMP6 = 6,
  TEMP7 = 7,
  CHECK_RESULT = 8,
  ARRAY_POS0 = 9,
  ARRAY_POS1 = 10,
  ARRAY_POS2 = 11,
  ARRAY_POS3 = 12,
  ARRAY_POS4 = 13,
  ARRAY_POS5 = 14,
  ARRAY_POS6 = 15,
  ARRAY_POS7 = 16,
  GLOBAL = 17,
  LOCAL = 18,
  OBJECT_ENTITY_POS = 19,
  OBJECT_GROUP_ID = 20,
  OBJECT_TYPE = 21,
  OBJECT_PROPERTY_VALUE = 22,
  OBJECT_XPOS = 23,
  OBJECT_YPOS = 24,
  OBJECT_IXPOS = 25,
  OBJECT_IYPOS = 26,
  OBJECT_XVEL = 27,
  OBJECT_YVEL = 28,
  OBJECT_SPEED = 29,
  OBJECT_STATE = 30,
  OBJECT_ROTATION = 31,
  OBJECT_SCALE = 32,
  OBJECT_PRIORITY = 33,
  OBJECT_DRAW_ORDER = 34,
  OBJECT_DIRECTION = 35,
  OBJECT_INK_EFFECT = 36,
  OBJECT_ALPHA = 37,
  OBJECT_FRAME = 38,
  OBJECT_ANIMATION = 39,
  OBJECT_PREV_ANIMATION = 40,
  OBJECT_ANIMATION_SPEED = 41,
  OBJECT_ANIMATION_TIMER = 42,
  OBJECT_ANGLE = 43,
  OBJECT_LOOK_POS_X = 44,
  OBJECT_LOOK_POS_Y = 45,
  OBJECT_COLLISION_MODE = 46,
  OBJECT_COLLISION_PLANE = 47,
  OBJECT_CONTROL_MODE = 48,
  OBJECT_CONTROL_LOCK = 49,
  OBJECT_PUSHING = 50,
  OBJECT_VISIBLE = 51,
  OBJECT_TILE_COLLISIONS = 52,
  OBJECT_INTERACTION = 53,
  OBJECT_GRAVITY = 54,
  OBJECT_UP = 55,
  OBJECT_DOWN = 56,
  OBJECT_LEFT = 57,
  OBJECT_RIGHT = 58,
  OBJECT_JUMP_PRESS = 59,
  OBJECT_JUMP_HOLD = 60,
  OBJECT_SCROLL_TRACKING = 61,
  OBJECT_FLOOR_SENSOR_L = 62,
  OBJECT_FLOOR_SENSOR_C = 63,
  OBJECT_FLOOR_SENSOR_R = 64,
  OBJECT_FLOOR_SENSOR_LC = 65,
  OBJECT_FLOOR_SENSOR_RC = 66,
  OBJECT_COLLISION_LEFT = 67,
  OBJECT_COLLISION_TOP = 68,
  OBJECT_COLLISION_RIGHT = 69,
  OBJECT_COLLISION_BOTTOM = 70,
  OBJECT_OUT_OF_BOUNDS = 71,
  OBJECT_SPRITE_SHEET = 72,
  OBJECT_VALUE0 = 73,
  OBJECT_VALUE1 = 74,
  OBJECT_VALUE2 = 75,
  OBJECT_VALUE3 = 76,
  OBJECT_VALUE4 = 77,
  OBJECT_VALUE5 = 78,
  OBJECT_VALUE6 = 79,
  OBJECT_VALUE7 = 80,
  OBJECT_VALUE8 = 81,
  OBJECT_VALUE9 = 82,
  OBJECT_VALUE10 = 83,
  OBJECT_VALUE11 = 84,
  OBJECT_VALUE12 = 85,
  OBJECT_VALUE13 = 86,
  OBJECT_VALUE14 = 87,
  OBJECT_VALUE15 = 88,
  OBJECT_VALUE16 = 89,
  OBJECT_VALUE17 = 90,
  OBJECT_VALUE18 = 91,
  OBJECT_VALUE19 = 92,
  OBJECT_VALUE20 = 93,
  OBJECT_VALUE21 = 94,
  OBJECT_VALUE22 = 95,
  OBJECT_VALUE23 = 96,
  OBJECT_VALUE24 = 97,
  OBJECT_VALUE25 = 98,
  OBJECT_VALUE26 = 99,
  OBJECT_VALUE27 = 100,
  OBJECT_VALUE28 = 101,
  OBJECT_VALUE29 = 102,
  OBJECT_VALUE30 = 103,
  OBJECT_VALUE31 = 104,
  OBJECT_VALUE32 = 105,
  OBJECT_VALUE33 = 106,
  OBJECT_VALUE34 = 107,
  OBJECT_VALUE35 = 108,
  OBJECT_VALUE36 = 109,
  OBJECT_VALUE37 = 110,
  OBJECT_VALUE38 = 111,
  OBJECT_VALUE39 = 112,
  OBJECT_VALUE40 = 113,
  OBJECT_VALUE41 = 114,
  OBJECT_VALUE42 = 115,
  OBJECT_VALUE43 = 116,
  OBJECT_VALUE44 = 117,
  OBJECT_VALUE45 = 118,
  OBJECT_VALUE46 = 119,
  OBJECT_VALUE47 = 120,
  STAGE_STATE = 121,
  STAGE_ACTIVE_LIST = 122,
  STAGE_LIST_POS = 123,
  STAGE_TIME_ENABLED = 124,
  STAGE_MILLI_SECONDS = 125,
  STAGE_SECONDS = 126,
  STAGE_MINUTES = 127,
  STAGE_ACT_NUM = 128,
  STAGE_PAUSE_ENABLED = 129,
  STAGE_LIST_SIZE = 130,
  STAGE_NEW_XBOUNDARY1 = 131,
  STAGE_NEW_XBOUNDARY2 = 132,
  STAGE_NEW_YBOUNDARY1 = 133,
  STAGE_NEW_YBOUNDARY2 = 134,
  STAGE_CUR_XBOUNDARY1 = 135,
  STAGE_CUR_XBOUNDARY2 = 136,
  STAGE_CUR_YBOUNDARY1 = 137,
  STAGE_CUR_YBOUNDARY2 = 138,
  STAGE_DEFORMATION_DATA0 = 139,
  STAGE_DEFORMATION_DATA1 = 140,
  STAGE_DEFORMATION_DATA2 = 141,
  STAGE_DEFORMATION_DATA3 = 142,
  STAGE_WATER_LEVEL = 143,
  STAGE_ACTIVE_LAYER = 144,
  STAGE_MID_POINT = 145,
  STAGE_PLAYER_LIST_POS = 146,
  STAGE_DEBUG_MODE = 147,
  STAGE_ENTITY_POS = 148,
  SCREEN_CAMERA_ENABLED = 149,
  SCREEN_CAMERA_TARGET = 150,
  SCREEN_CAMERA_STYLE = 151,
  SCREEN_CAMERA_X = 152,
  SCREEN_CAMERA_Y = 153,
  SCREEN_DRAW_LIST_SIZE = 154,
  SCREEN_XCENTER = 155,
  SCREEN_YCENTER = 156,
  SCREEN_XSIZE = 157,
  SCREEN_YSIZE = 158,
  SCREEN_XOFFSET = 159,
  SCREEN_YOFFSET = 160,
  SCREEN_SHAKE_X = 161,
  SCREEN_SHAKE_Y = 162,
  SCREEN_ADJUST_CAMERA_Y = 163,
  TOUCHSCREEN_DOWN = 164,
  TOUCHSCREEN_XPOS = 165,
  TOUCHSCREEN_YPOS = 166,
  MUSIC_VOLUME = 167,
  MUSIC_CURRENT_TRACK = 168,
  MUSIC_POSITION = 169,
  KEY_DOWN_UP = 170,
  KEY_DOWN_DOWN = 171,
  KEY_DOWN_LEFT = 172,
  KEY_DOWN_RIGHT = 173,
  KEY_DOWN_BUTTON_A = 174,
  KEY_DOWN_BUTTON_B = 175,
  KEY_DOWN_BUTTON_C = 176,
  KEY_DOWN_BUTTON_X = 177,
  KEY_DOWN_BUTTON_Y = 178,
  KEY_DOWN_BUTTON_Z = 179,
  KEY_DOWN_BUTTON_L = 180,
  KEY_DOWN_BUTTON_R = 181,
  KEY_DOWN_START = 182,
  KEY_DOWN_SELECT = 183,
  KEY_PRESS_UP = 184,
  KEY_PRESS_DOWN = 185,
  KEY_PRESS_LEFT = 186,
  KEY_PRESS_RIGHT = 187,
  KEY_PRESS_BUTTON_A = 188,
  KEY_PRESS_BUTTON_B = 189,
  KEY_PRESS_BUTTON_C = 190,
  KEY_PRESS_BUTTON_X = 191,
  KEY_PRESS_BUTTON_Y = 192,
  KEY_PRESS_BUTTON_Z = 193,
  KEY_PRESS_BUTTON_L = 194,
  KEY_PRESS_BUTTON_R = 195,
  KEY_PRESS_START = 196,
  KEY_PRESS_SELECT = 197,
  MENU1_SELECTION = 198,
  MENU2_SELECTION = 199,
  TILE_LAYER_XSIZE = 200,
  TILE_LAYER_YSIZE = 201,
  TILE_LAYER_TYPE = 202,
  TILE_LAYER_ANGLE = 203,
  TILE_LAYER_XPOS = 204,
  TILE_LAYER_YPOS = 205,
  TILE_LAYER_ZPOS = 206,
  TILE_LAYER_PARALLAX_FACTOR = 207,
  TILE_LAYER_SCROLL_SPEED = 208,
  TILE_LAYER_SCROLL_POS = 209,
  TILE_LAYER_DEFORMATION_OFFSET = 210,
  TILE_LAYER_DEFORMATION_OFFSET_W = 211,
  H_PARALLAX_PARALLAX_FACTOR = 212,
  H_PARALLAX_SCROLL_SPEED = 213,
  H_PARALLAX_SCROLL_POS = 214,
  V_PARALLAX_PARALLAX_FACTOR = 215,
  V_PARALLAX_SCROLL_SPEED = 216,
  V_PARALLAX_SCROLL_POS = 217,
  SCENE3D_VERTEX_COUNT = 218,
  SCENE3D_FACE_COUNT = 219,
  SCENE3D_PROJECTION_X = 220,
  SCENE3D_PROJECTION_Y = 221,
  SCENE3D_FOG_COLOR = 222,
  SCENE3D_FOG_STRENGTH = 223,
  VERTEX_BUFFER_X = 224,
  VERTEX_BUFFER_Y = 225,
  VERTEX_BUFFER_Z = 226,
  VERTEX_BUFFER_U = 227,
  VERTEX_BUFFER_V = 228,
  FACE_BUFFER_A = 229,
  FACE_BUFFER_B = 230,
  FACE_BUFFER_C = 231,
  FACE_BUFFER_D = 232,
  FACE_BUFFER_FLAG = 233,
  FACE_BUFFER_COLOR = 234,
  SAVE_RAM = 235,
  ENGINE_STATE = 236,
  ENGINE_LANGUAGE = 237,
  ENGINE_ONLINE_ACTIVE = 238,
  ENGINE_SFX_VOLUME = 239,
  ENGINE_BGM_VOLUME = 240,
  ENGINE_TRIAL_MODE = 241,
  ENGINE_DEVICE_TYPE = 242,
  SCREEN_CURRENT_ID = 243,
  CAMERA_ENABLED = 244,
  CAMERA_TARGET = 245,
  CAMERA_STYLE = 246,
  CAMERA_XPOS = 247,
  CAMERA_YPOS = 248,
  CAMERA_ADJUST_Y = 249,
  ENGINE_HAPTICS_ENABLED = 250,
  CAMERA_CUR_XBOUNDARY1 = 251,
  CAMERA_CUR_XBOUNDARY2 = 252,
  CAMERA_CUR_YBOUNDARY1 = 253,
  CAMERA_CUR_YBOUNDARY2 = 254,
  CAMERA_XOFFSET = 255,
  CAMERA_YOFFSET = 256,
  ENGINE_PLAYER_COUNT = 257,
  MAX_CNT = 258,
}

export const enum FUNC {
  END = 0,
  EQUAL = 1,
  ADD = 2,
  SUB = 3,
  INC = 4,
  DEC = 5,
  MUL = 6,
  DIV = 7,
  SH_R = 8,
  SH_L = 9,
  AND = 10,
  OR = 11,
  XOR = 12,
  MOD = 13,
  FLIP_SIGN = 14,
  CHECK_EQUAL = 15,
  CHECK_GREATER = 16,
  CHECK_LOWER = 17,
  CHECK_NOT_EQUAL = 18,
  IF_EQUAL = 19,
  IF_GREATER = 20,
  IF_GREATER_OR_EQUAL = 21,
  IF_LOWER = 22,
  IF_LOWER_OR_EQUAL = 23,
  IF_NOT_EQUAL = 24,
  ELSE = 25,
  ENDIF = 26,
  WEQUAL = 27,
  WGREATER = 28,
  WGREATER_OR_EQUAL = 29,
  WLOWER = 30,
  WLOWER_OR_EQUAL = 31,
  WNOT_EQUAL = 32,
  LOOP = 33,
  FOR_EACH_ACTIVE = 34,
  FOR_EACH_ALL = 35,
  NEXT = 36,
  SWITCH = 37,
  BREAK = 38,
  ENDSWITCH = 39,
  RAND = 40,
  SIN = 41,
  COS = 42,
  SIN256 = 43,
  COS256 = 44,
  ATAN2 = 45,
  INTERPOLATE = 46,
  INTERPOLATE_XY = 47,
  LOAD_SPRITE_SHEET = 48,
  REMOVE_SPRITE_SHEET = 49,
  DRAW_SPRITE = 50,
  DRAW_SPRITE_XY = 51,
  DRAW_SPRITE_SCREEN_XY = 52,
  DRAW_TINT_RECT = 53,
  DRAW_NUMBERS = 54,
  DRAW_ACT_NAME = 55,
  DRAW_MENU = 56,
  SPRITE_FRAME = 57,
  EDIT_FRAME = 58,
  LOAD_PALETTE = 59,
  ROTATE_PALETTE = 60,
  SET_SCREEN_FADE = 61,
  SET_ACTIVE_PALETTE = 62,
  SET_PALETTE_FADE = 63,
  SET_PALETTE_ENTRY = 64,
  GET_PALETTE_ENTRY = 65,
  COPY_PALETTE = 66,
  CLEAR_SCREEN = 67,
  DRAW_SPRITE_FX = 68,
  DRAW_SPRITE_SCREEN_FX = 69,
  LOAD_ANIMATION = 70,
  SETUP_MENU = 71,
  ADD_MENU_ENTRY = 72,
  EDIT_MENU_ENTRY = 73,
  LOAD_STAGE = 74,
  DRAW_RECT = 75,
  RESET_OBJECT_ENTITY = 76,
  BOX_COLLISION_TEST = 77,
  CREATE_TEMP_OBJECT = 78,
  PROCESS_OBJECT_MOVEMENT = 79,
  PROCESS_OBJECT_CONTROL = 80,
  PROCESS_ANIMATION = 81,
  DRAW_OBJECT_ANIMATION = 82,
  SET_MUSIC_TRACK = 83,
  PLAY_MUSIC = 84,
  STOP_MUSIC = 85,
  PAUSE_MUSIC = 86,
  RESUME_MUSIC = 87,
  SWAP_MUSIC_TRACK = 88,
  PLAY_SFX = 89,
  STOP_SFX = 90,
  SET_SFX_ATTRIBUTES = 91,
  OBJECT_TILE_COLLISION = 92,
  OBJECT_TILE_GRIP = 93,
  NOT = 94,
  DRAW3DSCENE = 95,
  SET_IDENTITY_MATRIX = 96,
  MATRIX_MULTIPLY = 97,
  MATRIX_TRANSLATE_XYZ = 98,
  MATRIX_SCALE_XYZ = 99,
  MATRIX_ROTATE_X = 100,
  MATRIX_ROTATE_Y = 101,
  MATRIX_ROTATE_Z = 102,
  MATRIX_ROTATE_XYZ = 103,
  MATRIX_INVERSE = 104,
  TRANSFORM_VERTICES = 105,
  CALL_FUNCTION = 106,
  RETURN = 107,
  SET_LAYER_DEFORMATION = 108,
  CHECK_TOUCH_RECT = 109,
  GET_TILE_LAYER_ENTRY = 110,
  SET_TILE_LAYER_ENTRY = 111,
  GET_BIT = 112,
  SET_BIT = 113,
  CLEAR_DRAW_LIST = 114,
  ADD_DRAW_LIST_ENTITY_REF = 115,
  GET_DRAW_LIST_ENTITY_REF = 116,
  SET_DRAW_LIST_ENTITY_REF = 117,
  GET16X16TILE_INFO = 118,
  SET16X16TILE_INFO = 119,
  COPY16X16TILE = 120,
  GET_ANIMATION_BY_NAME = 121,
  READ_SAVE_RAM = 122,
  WRITE_SAVE_RAM = 123,
  LOAD_TEXT_FILE = 124,
  GET_TEXT_INFO = 125,
  GET_VERSION_NUMBER = 126,
  GET_TABLE_VALUE = 127,
  SET_TABLE_VALUE = 128,
  CHECK_CURRENT_STAGE_FOLDER = 129,
  ABS = 130,
  CALL_NATIVE_FUNCTION = 131,
  CALL_NATIVE_FUNCTION2 = 132,
  CALL_NATIVE_FUNCTION4 = 133,
  SET_OBJECT_RANGE = 134,
  GET_OBJECT_VALUE = 135,
  SET_OBJECT_VALUE = 136,
  COPY_OBJECT = 137,
  PRINT = 138,
  CHECK_CAMERA_PROXIMITY = 139,
  SET_SCREEN_COUNT = 140,
  SET_SCREEN_VERTICES = 141,
  GET_INPUT_DEVICE_ID = 142,
  GET_FILTERED_INPUT_DEVICE_ID = 143,
  GET_INPUT_DEVICE_TYPE = 144,
  IS_INPUT_DEVICE_ASSIGNED = 145,
  ASSIGN_INPUT_SLOT_TO_DEVICE = 146,
  IS_INPUT_SLOT_ASSIGNED = 147,
  RESET_INPUT_SLOT_ASSIGNMENTS = 148,
  MAX_CNT = 149,
}
